<template>

    <div id="api-documentation">
        <Documentation></Documentation>
    </div>

</template>

<script>
import Documentation from "./Documentation";

export default {
    name: "APIDocumentation",
    components: {
        Documentation
    }
}
</script>
